
import { Link } from 'react-router-dom';

export default function CalendarHero() {
  return (
    <section className="relative h-[420px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/74680b1cd13ce552d5915fd5845686d6.jpg"
          alt="Roseville Community Events"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6 pt-20">
        <nav className="flex items-center space-x-2 text-sm text-white/70 mb-4">
          <Link to="/" className="hover:text-white transition-colors cursor-pointer">Home</Link>
          <i className="ri-arrow-right-s-line text-base"></i>
          <Link to="/events" className="hover:text-white transition-colors cursor-pointer">Events</Link>
          <i className="ri-arrow-right-s-line text-base"></i>
          <span className="text-white">Calendar</span>
        </nav>
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
          Community Events Calendar
        </h1>
        <p className="text-lg text-white/80 max-w-2xl">
          Discover festivals, concerts, markets, and community gatherings happening across Roseville. Filter by category or date to find your next adventure.
        </p>
      </div>
    </section>
  );
}
